import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '549a0fed-e0f1-45fa-83ad-b5a16080ff22',
    countryCodes: ['DE'],
    locale: 'de-DE',
});
